const DARK_GRAY = `rgb(30, 30, 30)`;
const MAX_LIGHTNESS = 50;
const MIN_LIGHTNESS = 12;
const SATURATION = 45;


export const getRedCellColor = (value, maxValue) => {
  if (value === 0 || !maxValue) return DARK_GRAY;

  const normalizedValue = Math.min(1, value / maxValue);
  const hue = 0;
  const lightness = MIN_LIGHTNESS + normalizedValue * (MAX_LIGHTNESS - MIN_LIGHTNESS);

  return `hsl(${hue}, ${SATURATION}%, ${lightness}%)`;
};

export const getGreenCellColor = (value, maxValue) => {
  if (value === 0 || !maxValue) return DARK_GRAY;

  const normalizedValue = Math.min(1, value / maxValue);
  const hue = 128;
  const lightness = MIN_LIGHTNESS + normalizedValue * (MAX_LIGHTNESS - MIN_LIGHTNESS);

  return `hsl(${hue}, ${SATURATION}%, ${lightness}%)`;
};


export const getRedGreenCell = (value, minValue, maxValue) => {
  if (value === 0 || (!minValue && !maxValue)) return DARK_GRAY;

  const normalizedValue = value > 0
    ? Math.min(1, Math.abs(value) / (maxValue || 1))
    : Math.min(1, Math.abs(value / (minValue || 1)));

  const hue = value > 0 ? 120 : 0;
  const lightness = MIN_LIGHTNESS + normalizedValue * (MAX_LIGHTNESS - MIN_LIGHTNESS);

  return `hsl(${hue}, ${SATURATION}%, ${lightness}%)`;
};


export const getRedGreenCellno0 = (value, minValue, maxValue) => {
  if (minValue === maxValue) return DARK_GRAY;

  const midpoint = (minValue + maxValue) / 2;
  const normalizedValue = value > midpoint
    ? Math.min(1, (value - midpoint) / (maxValue - midpoint || 1))
    : Math.min(1, (midpoint - value) / (midpoint - minValue || 1));

  const hue = value > midpoint ? 120 : 0;
  const lightness = MIN_LIGHTNESS + normalizedValue * (MAX_LIGHTNESS - MIN_LIGHTNESS);

  return `hsl(${hue}, ${SATURATION}%, ${lightness}%)`;
};

export const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};


export const GROUP_COLORS = {
  base: "#2a2a2a",
  early: "rgba(255, 160, 200, 0.35)",
  mid: "rgba(199,39,199,0.35)",
  damage: "rgba(255,120,120,0.35)",
  economy: "rgba(255,215,100,0.35)",
  farming: "rgba(100,200,255,0.35)",
  proximity: "rgba(255,255,255,0.15)",
  vision: "rgba(200,160,255,0.35)",
  combat: "rgba(255,200,150,0.35)",
};

export const STAT_GROUPS = {
  base: {
    label: "Base",
    color: GROUP_COLORS.base,
  },
  early: {
    label: "Early Game (0–8)",
    color: GROUP_COLORS.early,
  },
  mid: {
    label: "Mid Game (8–14)",
    color: GROUP_COLORS.mid,
  },
  damage: {
    label: "Damage",
    color: GROUP_COLORS.damage,
  },
  economy: {
    label: "Economy",
    color: GROUP_COLORS.economy,
  },
  farming: {
    label: "Farming",
    color: GROUP_COLORS.farming,
  },
  proximity: {
    label: "Proximity",
    color: GROUP_COLORS.proximity,
  },
  vision: {
    label: "Vision",
    color: GROUP_COLORS.vision,
  },
  combat: {
    label: "Combat",
    color: GROUP_COLORS.combat,
  },
};

export const playerColumns = {
  summonerName: { group: "base" },
  Records: { group: "base" },
  counterPick: { group: "base" },
  KDA: { group: "base" },

  // EARLY
  killsAndAssists8: { group: "early" },
  deaths8: { group: "early" },
  recalls8: { group: "early" },
  goldDiff8: { group: "early" },
  csDiff8: { group: "early" },
  expDiff8: { group: "early" },
  wardPlaced8: { group: "early" },
  wardKilled8: { group: "early" },
  visionScore8: { group: "early" },
  firstLevel2: { group: "early" },
  firstLevel6: { group: "early" },
  level6Time: { group: "early" },

  // MID
  killsAndAssists14: { group: "mid" },
  deaths14: { group: "mid" },
  recalls14: { group: "mid" },
  goldDiff14: { group: "mid" },
  csDiff14: { group: "mid" },
  expDiff14: { group: "mid" },
  wardPlaced14: { group: "mid" },
  wardKilled14: { group: "mid" },
  visionScore14: { group: "mid" },

  // DAMAGE
  damageShared: { group: "damage" },
  DamageDealt: { group: "damage" },
  DMGShared15: { group: "damage" },
  DMG15: { group: "damage" },

  DMGShared15end: { group: "damage" },
  dmgPerMinute15ToEnd: { group: "damage" },
  TowerPlateDMG: { group: "damage" },

  // ECONOMY
  GD5: { group: "economy" },
  GD10: { group: "economy" },
  GD15: { group: "economy" },
  goldShared: { group: "economy" },
  GoldEarned: { group: "economy" },

  GOLDShared15: { group: "economy" },
  GOLD15: { group: "economy" },
  GOLDShared15end: { group: "economy" },
  goldPerMinute15ToEnd: { group: "economy" },

  // FARMING
  CS: { group: "farming" },

  csPerMin_0_5: { group: "farming" },
  csPerMin_5_10: { group: "farming" },
  csPerMin_10_15: { group: "farming" },
  csPerMin_0_15: { group: "farming" },
  csDiff_0_5: { group: "farming" },
  csDiff_5_10: { group: "farming" },
  csDiff_10_15: { group: "farming" },
  csDiff_0_15: { group: "farming" },
  csDiff_20_end: { group: "farming" },
  TakenEnemyCamp4_7: { group: "farming" },

  // PROXIMITY
  TopProximity: { group: "proximity" },
  JglProximity: { group: "proximity" },
  MidProximity: { group: "proximity" },
  BotProximity: { group: "proximity" },
  SupProximity: { group: "proximity" },
  JungleProximity: { group: "proximity" },
  JungleProximityEnd: { group: "proximity" },
  enemyJungleProximity15: { group: "proximity" },
  enemyJungleProximityEnd: { group: "proximity" },

  // VISION
  wardPlaced: { group: "vision" },
  wardKilled: { group: "vision" },
  visionScore: { group: "vision" },

  wardPlacedPerMin: { group: "vision" },
  wardKilledPerMin: { group: "vision" },
  ControlWardsBought: { group: "vision" },
  ControlWardsBoughtPerMin: { group: "vision" },

  kills: { group: "combat" },
  deaths: { group: "combat" },
  assists: { group: "combat" },

  firstDeath: { group: "combat" },
  soloKills: { group: "combat" },
  IsolatedDeaths20plus: { group: "combat" },
  recalls: { group: "combat" },
};
const base = "#1a1a1a";
const makeGradient = (color) => `linear-gradient(180deg, ${base}, ${color})`;

// Common gradient variants
const dark = makeGradient("#2a2a2a, #1a1a1a");
const pink = makeGradient("rgba(255, 160, 200, 0.15)");
const purple = makeGradient("rgba(199,39,199,0.18)");
const red = makeGradient("rgba(255,120,120,0.18)");
const gold = makeGradient("rgba(255,215,100,0.18)");
const blue = makeGradient("rgba(100,200,255,0.18)");
const white = makeGradient("rgba(255,255,255,0.1)");
const violet = makeGradient("rgba(200,160,255,0.18)");
const peach = makeGradient("rgba(255,200,150,0.18)");

export const backgroundColor = {
  // Base
  A: dark,
  summonerName: dark,
  displayName: dark,
  rounds: dark,

  games: dark,
  matches: dark,
  championName: dark,
  enemyChampionName: dark,
  teamName: dark,
  enemyTeamName: dark,
  counterPick: dark,
  winner: dark,
  scrimId: dark,
  totalWins: dark,
  gameId: dark,
  date: dark,
  patch: dark,

  // Early game (8 min)
  killsAndAssists8: pink,
  deaths8: pink,
  recalls8: pink,
  goldDiff8: pink,
  csDiff8: pink,
  expDiff8: pink,
  wardPlaced8: pink,
  wardKilled8: pink,
  visionScore8: pink,
  firstLevel2: pink,
  firstLevel6: pink,
  level6Time: pink,

  // Mid game (14 min)
  killsAndAssists14: purple,
  deaths14: purple,
  recalls14: purple,
  goldDiff14: purple,
  csDiff14: purple,
  expDiff14: purple,
  wardPlaced14: purple,
  wardKilled14: purple,
  visionScore14: purple,
  questTime: purple,
  firstQuest: purple,

  // Damage
  damageShared: red,
  DamageDealt: red,
  DMGShared15: red,
  DMG15: red,
  DMGShared15end: red,
  dmgPerMinute15ToEnd: red,
  TowerPlateDMG: red,

  // Gold
  GD5: gold,
  GD10: gold,
  GD15: gold,
  goldShared: gold,
  GoldEarned: gold,
  GOLDShared15: gold,
  GOLD15: gold,
  GOLDShared15end: gold,
  goldPerMinute15ToEnd: gold,

  // CS
  CS: blue,
  csPerMin_0_5: blue,
  csPerMin_5_10: blue,
  csPerMin_10_15: blue,
  csPerMin_0_15: blue,
  csDiff_0_5: blue,
  csDiff_5_10: blue,
  csDiff_10_15: blue,
  csDiff_0_15: blue,
  csDiff_20_end: blue,
  TakenEnemyCamp4_7: blue,

  // Proximity
  TopProximity: white,
  JglProximity: white,
  MidProximity: white,
  BotProximity: white,
  SupProximity: white,
  JungleProximity: white,
  JungleProximityEnd: white,
  enemyJungleProximity15: white,
  enemyJungleProximityEnd: white,
  DuoProximity: white,

  // Vision
  wardPlaced: violet,
  wardPlacedPerMin: violet,
  wardKilled: violet,
  wardKilledPerMin: violet,
  visionScore: violet,
  ControlWardsBought: violet,
  ControlWardsBoughtPerMin: violet,

  // KDA & combat
  firstDeath: peach,
  soloKills: peach,
  IsolatedDeaths20plus: peach,
  recalls: peach,
  kills: peach,
  deaths: peach,
  assists: peach,
  KDA: peach,
  firstBlood: peach,
  feats: peach,
  featsEpic: peach,
  featsKills: peach,
  featsTower: peach,

  // Objectives
  firstVoidgrub: red,
  voidGrubKilled: red,
  firstHerald: red,
  firstDragon: red,
  dragonsBefore14: red,
  dragonsAll14: red,
  firstBaron: red,
  baronAll: red,
  firstAtakhan: red,

  // Towers
  firstTower: gold,
  TopTurretPlates: gold,
  MidTurretPlates: gold,
  BotTurretPlates: gold,
  towersBefore14: gold,

  // Team stats
  TeamGoldDiff8: blue,
  TeamCsDiff8: blue,
  TeamExpDiff8: blue,
  TeamGoldDiff14: blue,
  TeamCsDiff14: blue,
  TeamExpDiff14: blue,
};

